import { render, staticRenderFns } from "./TooltipTextOvertime.vue?vue&type=template&id=0c2a9790"
import script from "./TooltipTextOvertime.vue?vue&type=script&lang=js"
export * from "./TooltipTextOvertime.vue?vue&type=script&lang=js"
import style0 from "./TooltipTextOvertime.vue?vue&type=style&index=0&id=0c2a9790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports